import { Link } from "react-router-dom";

interface ThankYouProps {
  onReset: () => void;
}

/**
 * Entra no lugar do formulário quando o envio dá certo. Diz o prazo real
 * de resposta e deixa duas saídas claras, sem prender ninguém na página.
 */
export function ThankYou({ onReset }: ThankYouProps) {
  return (
    <div className="max-w-[56ch]">
      <p className="jg-eyebrow text-jg-accent">Recebido</p>

      <h2 className="mt-5 font-display text-[length:var(--text-step-2)] font-medium leading-tight tracking-[-0.015em]">
        Chegou aqui. Obrigado pelo detalhe.
      </h2>

      <p className="mt-5 leading-relaxed text-jg-fg-muted">
        Eu leio todos e respondo em até 24 horas, com uma pergunta sobre o
        escopo ou com um horário para conversar. Se for urgente,{" "}
        <a className="jg-link" href="mailto:joao@jgson.net">
          joao@jgson.net
        </a>{" "}
        cai direto na minha caixa.
      </p>

      <div className="mt-8 flex flex-wrap items-center gap-x-7 gap-y-3">
        <Link className="jg-button" to="/">
          Voltar para o início
        </Link>
        <button type="button" onClick={onReset} className="jg-link text-sm">
          enviar outro
        </button>
      </div>
    </div>
  );
}
